import { render, staticRenderFns } from "./ZettaLogo.vue?vue&type=template&id=39910aff&scoped=true"
import script from "./ZettaLogo.vue?vue&type=script&lang=js"
export * from "./ZettaLogo.vue?vue&type=script&lang=js"
import style0 from "./ZettaLogo.vue?vue&type=style&index=0&id=39910aff&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39910aff",
  null
  
)

export default component.exports